"use client"

import { useState } from "react"
import Win95Button from "../Win95Button"
import PasswordField from "./PasswordField"

type ChatSettingsMenuProps = {
	onClose: () => void
}

export default function ChatSettingsMenu({ onClose }: ChatSettingsMenuProps) {
	const [currentPassword, setCurrentPassword] = useState("")
	const [newPassword, setNewPassword] = useState("")
	const [confirmPassword, setConfirmPassword] = useState("")
	const [error, setError] = useState<string | null>(null)
	const [success, setSuccess] = useState(false)
	const [submitting, setSubmitting] = useState(false)

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault()
		setError(null)
		setSuccess(false)

		if (newPassword !== confirmPassword) {
			setError("New passwords do not match.")
			return
		}

		setSubmitting(true)
		try {
			const res = await fetch("/api/trashchat/change-password", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ currentPassword, newPassword }),
			})
			const data = await res.json()
			if (!res.ok) {
				setError(data.error ?? "Failed to change password.")
				return
			}
			setSuccess(true)
			setCurrentPassword("")
			setNewPassword("")
			setConfirmPassword("")
		} catch {
			setError("Network error. Try again.")
		} finally {
			setSubmitting(false)
		}
	}

	return (
		<div
			className="
				absolute right-2 top-9 z-20
				w-64 text-left
				bg-[#0d0020]
				border-2 border-t-[#00f5ff] border-l-[#00f5ff] border-b-[#ff003c] border-r-[#ff003c]
				p-3 flex flex-col gap-2
				shadow-[0_0_14px_rgba(191,0,255,0.5)]
			"
		>
			<div className="flex items-center justify-between">
				<span className="text-sm font-bold text-[#39ff14]">Settings</span>
				<button type="button" onClick={onClose} className="text-xs text-[#ff003c] hover:opacity-70">
					close
				</button>
			</div>

			<form onSubmit={handleSubmit} className="flex flex-col gap-2">
				<div className="text-xs font-bold text-[#ffe600]">Change Password</div>
				<PasswordField
					label="Current password"
					value={currentPassword}
					onChange={setCurrentPassword}
					autoComplete="current-password"
					required
				/>
				<PasswordField
					label="New password"
					value={newPassword}
					onChange={setNewPassword}
					autoComplete="new-password"
					required
				/>
				<PasswordField
					label="Confirm new password"
					value={confirmPassword}
					onChange={setConfirmPassword}
					autoComplete="new-password"
					required
				/>
				{error && <div className="text-xs text-[#ff003c] font-bold">{error}</div>}
				{success && <div className="text-xs text-[#39ff14] font-bold">Password changed!</div>}
				<Win95Button label={submitting ? "..." : "Update Password"} />
			</form>
		</div>
	)
}
